import { RecurringProfileActions } from '../actions/actionTypes'
import { RecurringProfileSettingsInterface } from '../Interfaces/RecurringProfileInterface'
import { ReducerBuilder } from './ReducerBuilder'

type StateType = RecurringProfileSettingsInterface
type PayloadType = RecurringProfileSettingsInterface

const INITIAL_STATE = {}

const reducer = new ReducerBuilder<StateType, PayloadType>(INITIAL_STATE)
  .mapAction(
    RecurringProfileActions.UPDATE_RECURRING_PROFILE_SETTINGS,
    (state: StateType, payload: RecurringProfileSettingsInterface) => payload,
  )
  .mapAction(RecurringProfileActions.DELETE_RECURRING_PROFILE_SETTINGS, (state: StateType, payload: undefined) => null)
  .build()

export default reducer
